import React from "react"
import styled from "styled-components"
import { Link } from "react-scroll"
// Assets
import logo from "../../assets/img/logo.png"

export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear()
  }

  return (
    <Wrapper>
      <div className="whiteBg">
        <div className="container">
          <InnerWrapper
            className="flexSpaceCenter"
            style={{ padding: "30px 0" }}
          >
            <Link
              className="flexCenter animate pointer"
              to="home"
              smooth={true}
              offset={-80}
            >
              <img
                src={logo}
                className="logo"
                alt="Boditel logo"
                height={30}
                width={120}
              />
            </Link>
            <StyleP className="blackColor font13">
              © {getCurrentYear()} -{" "}
              <span className="purpleColor font13">Boditel Corporation</span>{" "}
              All Right Reserved
            </StyleP>

            <Link
              className="blackColor animate pointer font13"
              to="home"
              smooth={true}
              offset={-80}
            >
              Back to top
            </Link>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
`
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`
